module.exports = __webpack_public_path__ + "assets/paypal-credit.86593fa4.svg";